import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColumn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5
	},
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.672681,0,0,0.719677,4.187846,0.822883)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.269,2.04L17.82,2.04C17.82,2.04 19.432,2.004 19.432,3.652C19.432,5.301 17.793,5.292 17.793,5.292L5.16,5.292C5.16,5.292 3.632,5.255 3.652,3.62C3.673,2.004 5.269,2.04 5.269,2.04Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.672681,0,0,0.719677,4.283698,17.900445)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M5.269,2.04L17.82,2.04C17.82,2.04 19.432,2.004 19.432,3.652C19.432,5.301 17.793,5.292 17.793,5.292L5.16,5.292C5.16,5.292 3.632,5.255 3.652,3.62C3.673,2.004 5.269,2.04 5.269,2.04Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "2.15px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.920185,0,0,0.934265,0.909853,-0.24461)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M8.002,5.219L15.962,5.219C15.962,5.219 13.885,5.173 13.904,7.414C13.922,9.655 13.904,19.018 13.904,19.018C13.904,19.018 13.958,20.967 15.944,20.985C17.929,21.003 8.02,20.985 8.02,20.985C8.02,20.985 10.042,21.003 10.024,19.036C10.005,17.069 10.024,7.596 10.024,7.596C10.024,7.596 10.169,5.173 8.002,5.219Z",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.62px"
				}
			})
		})
	]
});
export default SvgColumn;
